module.exports = __webpack_public_path__ + "static/media/right.09044f00.svg";